/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: file is too large
 * @export
 * @interface PaxCheckFileTooLarge
 */
export interface PaxCheckFileTooLarge {
    /**
     * Max file size in bytes
     * @type {number}
     * @memberof PaxCheckFileTooLarge
     */
    maxSize: number;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFileTooLarge
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFileTooLarge interface.
 */
export function instanceOfPaxCheckFileTooLarge(value: object): value is PaxCheckFileTooLarge {
    if (!('maxSize' in value) || value['maxSize'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFileTooLargeFromJSON(json: any): PaxCheckFileTooLarge {
    return PaxCheckFileTooLargeFromJSONTyped(json, false);
}

export function PaxCheckFileTooLargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFileTooLarge {
    if (json == null) {
        return json;
    }
    return {
        
        'maxSize': json['maxSize'],
        'type': json['type'],
    };
}

export function PaxCheckFileTooLargeToJSON(json: any): PaxCheckFileTooLarge {
    return PaxCheckFileTooLargeToJSONTyped(json, false);
}

export function PaxCheckFileTooLargeToJSONTyped(value?: PaxCheckFileTooLarge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxSize': value['maxSize'],
        'type': value['type'],
    };
}

